import React, { useEffect, useState } from 'react';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { Col, Container, Row } from 'react-grid-system';
import { useForm } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';

import { useApp } from '../../_libs/hooks/useApp';
import { useBrand } from '../../_libs/hooks/useBrand';
import Navigation from '../../molecules/Navigation';
import ErrorBoundary from '../../organisms/ErrorBoundary';

const IntroZipCode = (): JSX.Element => {
  const {
    zipCode,
    setZipCode,
    reportData,
    userId,
  } = useApp();
  const {
    primaryBrand,
    coBrand,
  } = useBrand();
  const { 
    register,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm();
  const navigate = useNavigate();
  const [orgName, setOrgName] = useState<string>(null);

  useEffect(() => { 
    if (primaryBrand) {
      const hasValidOrgName = (
        primaryBrand.name &&
        primaryBrand.name !== '' &&
        primaryBrand.name.length
      );
      if (hasValidOrgName) { setOrgName(primaryBrand.name); } 
      else { navigate('/name/'); }
    }
  }, [primaryBrand.name]);

  function onSubmit (formData: Record<any, any>) {
    const zip = formData.zipCode.trim();
    axios
      .get(`/data_zip/${zip}/`)
      .then((res: AxiosResponse) => {
        const data = res.data;
        if (data.status === 'OK' && data.zip) {
          setZipCode(data.zip.zipCode);
          axios
            .post('/update_report/', {
              reportId: reportData.id,
              organizationId: primaryBrand.id,
              coBrandId: coBrand.id,
              key: 'zipId',
              value: data.zip.id,
              userId,
            }).catch((err) => {
              console.error(err);
            });
          navigate('/radius/');
        } else {
          setError('zipCode', {
            type: 'custom',
            message: `Could not find data for ${zip}. Please enter a different 5-digit ZIP code.`,
          });
        }
      })
      .catch((err: AxiosError) => {
        throw new Error(err.message);
      });
  }

  return (
    <ErrorBoundary>
      <Navigation />
      <Container>
        <Row align="center" style={{
          minHeight: 'calc(100vh - 105px)',
          paddingBottom: '52.5px',
        }}>
          <Col sm={8}>
            <form onSubmit={ handleSubmit(onSubmit) }>
              <label className="block">
                <h1 className="f-serif f-normal">
                  Enter a 5-digit ZIP Code for <Link className="nowrap f-italic" to="/organization/">{orgName}</Link>
                </h1>
                <input
                  className="mb-2 block"
                  name="zipCode"
                  defaultValue={zipCode}
                  {
                    ...register('zipCode', {
                      required: 'A ZIP code is required.',
                      minLength: {
                        value: 5,
                        message: 'Too short. You must enter a 5-digit ZIP code.'
                      },
                      maxLength: {
                        value: 5,
                        message: 'Too long. You must enter a 5-digit ZIP code.'
                      },
                      pattern: {
                        value: /[0-9]/,
                        message: 'This input only accepts numbers, 0-9.',
                      },
                    })
                  }
                />
              </label>
              {
                errors.zipCode && 
                  <p>{ errors.zipCode.message.toString() }</p>
              }
              <button type="submit" className="block mt-4">Next</button>
            </form>
          </Col>
        </Row>
      </Container>
    </ErrorBoundary>
  );
};

export default IntroZipCode;
